export function getToken() {
  return localStorage.getItem('access_token')
}
